export { default } from './GoogleReviewsAndPress'
